import {useQuery} from 'react-query';
import useAxios from 'config/RequestInterceptor';


interface UserProps {
    user_id: number
}

const time = {
    cacheTime: 1000 * 60 * 60 * 24
};

const getUser = async (values?: UserProps) => {
    // return await useAxios.get(`/wp-json/sbaj/v1/users/${values.user_id}`).then(data => data.data);
    return await useAxios.get(`/api/users/me`).then(data => data.data);
};

export const useGetUser = (values?: UserProps) => {
    return useQuery(
        'get-user',
        () => getUser(values),
        time
    );
};

export default useGetUser;
